import { render } from "./EventSkeleton.vue?vue&type=template&id=51706782&scoped=true"
import script from "./EventSkeleton.vue?vue&type=script&lang=js"
export * from "./EventSkeleton.vue?vue&type=script&lang=js"

import "./EventSkeleton.vue?vue&type=style&index=0&id=51706782&scoped=true&lang=css"

import exportComponent from "C:\\code repo\\iebrewers.org\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51706782"]])

export default __exports__